module.exports = new __parcel__URL__("jsw-user-limit.f13caea6.png").toString();